import React, { FC } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { ContentImagesFragmentFragment } from "@graphqlTypes"

import ContentBreakout from "../ContentBreakout/ContentBreakout"
import ContentCaption from "../ContentCaption/ContentCaption"

import {
  ContentImagesFIGURE,
} from "./ContentImages.styles"
import { generateConditionalClassName } from "@utils"
import { CONTENT_MAX_WIDTH } from "@constants"

export enum CONTENT_IMAGES_LAYOUTS {
  SINGLE = "SINGLE",
  SINGLE_WIDE = "SINGLE_WIDE",
  TWO_UP = "TWO_UP",
  TWO_UP_WIDE = "TWO_UP_WIDE",
  THREE_UP = "THREE_UP",
}

const ContentImages: FC<ContentImagesFragmentFragment & { layout?: CONTENT_IMAGES_LAYOUTS }> = ({
  caption,
  images,
  layout = CONTENT_IMAGES_LAYOUTS.SINGLE,
}) => !images ? null : (
  <ContentBreakout className={caption ? "has-caption" : ""}>
    <div className="container">
      <div className="grid">
        <div className={generateConditionalClassName({
          column: true,
          "column--2-12-M": [
            CONTENT_IMAGES_LAYOUTS.SINGLE_WIDE,
            CONTENT_IMAGES_LAYOUTS.TWO_UP_WIDE
          ].includes(layout),
        })}>
          <ContentImagesFIGURE
            className={generateConditionalClassName({
              [`layout--${layout}`]: true,
            })}
          >
            {images?.map((image, i) => {
              if (!image) return null

              const isGif = image.file?.url?.includes(".gif")

              return (
                isGif ?
                  <div
                    key={image.id}
                    className={`grid-item-${i + 1}`}
                  >
                    <img src={`https:${image?.file?.url}`} />
                  </div>
                  :
                  <div
                    key={image.id}
                    className={`grid-item-${i + 1}`}
                  >
                    <GatsbyImage
                      alt={image.title || "Image"}
                      image={image?.imgixImage?.gatsbyImageData}
                      style={{
                        maxWidth: image.width && image.width < CONTENT_MAX_WIDTH ? image.width : undefined
                      }}
                    />
                  </div>
              )
            })}
          </ContentImagesFIGURE>
          {caption && (
            <ContentCaption>
              {caption}
            </ContentCaption>
          )}
        </div>
      </div>
    </div>
  </ContentBreakout >
)

export const ContentImagesFragment = graphql`
  fragment ContentImagesImageFragment on ContentfulAsset {
    contentful_id
    id
    imgixImage {
      url
      gatsbyImageData(width: 1323)
    }
    file {
      fileName
      url
    }
    title
    width
  }
  fragment ContentImagesFragment on ContentfulContentBlockImages {
    contentful_id
    entryTitle
    layout
    caption
    images {
      ...ContentImagesImageFragment
    }
  }
`

export default ContentImages
